import { ButtonType } from '../model/ButtonModel';
import { StoreState } from '../store-interfaces';

export const mainMenuButtonsSelector = (state: StoreState) => {
  return state.mainMenu.entities
    .map(b => ({
      id: b.id,
      name: b.title,
      sortOrder: b.sortOrder,
      type: b.type === 'web_url' ? ButtonType.URL : ButtonType.PAGE,
      config: {
        url: b.url,
        pageId:
          b.payload && typeof b.payload === 'string'
            ? b.payload.slice(b.payload.lastIndexOf(':') + 1)
            : undefined,
      },
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder);
};
